import { Link } from 'react-router-dom';
import { useTournamentsList } from 'modules/jogador/tournaments/useTournamentsList';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { tournamentDetailPath } from 'shared/constants/routes';
import { AsyncSection } from 'shared/components/ui/LoadingState';
import { TournamentCardSkeleton } from 'modules/jogador/tournaments/components/TournamentSkeletons';

export function TournamentsListPage() {
  const { tournaments, isLoading, error } = useTournamentsList();

  return (
    <section className="mx-auto max-w-2xl px-4 py-8">
      <h1 className="font-heading text-2xl font-bold text-ink">Torneios</h1>
      <p className="mt-1 text-sm text-ink-secondary">Inscreva-se com sua dupla e dispute nas arenas parceiras.</p>

      <AsyncSection
        isLoading={isLoading}
        error={error}
        loadingLabel="Carregando torneios..."
        skeleton={
          <div className="mt-6 flex flex-col gap-3">
            <TournamentCardSkeleton />
            <TournamentCardSkeleton />
          </div>
        }
      >
        <div className="mt-6 flex flex-col gap-3">
          {tournaments.map((tournament) => (
            <Link key={tournament.id} to={tournamentDetailPath(tournament.id)}>
              <Card className="hover:border-primary">
                <Badge tone="accent">{tournament.sport}</Badge>
                <h2 className="mt-2 font-heading text-lg font-semibold text-ink">{tournament.name}</h2>
                <p className="text-sm text-ink-secondary">
                  {tournament.dateLabel} · {tournament.arenaName}
                </p>
                <p className="mt-2 text-sm font-medium text-primary">{tournament.entryFeeLabel}</p>
              </Card>
            </Link>
          ))}
        </div>
      </AsyncSection>
    </section>
  );
}
